import { firestoreAction } from 'vuexfire';
import fb from '@/firebaseConfig';

const state = {
  assets: {},
  selected: [],
  active: {},
};

const getters = {
  assets(state) {
    return state.assets;
  },
  selected(state) {
    return state.selected;
  },
  assetsFilteredByTitle: (state) => (title) => {
    return state.assets.filter((asset) => asset.title.toLowerCase().indexOf(title) > -1);
  },
  active(state) {
    return state.active;
  },
};

const mutations = {
  SELECT(state, data) {
    state.selected.push(data);
  },
  DESELECT(state, data) {
    const index = state.selected.indexOf(data);
    if (index !== -1) state.selected.splice(index, 1);
  },
  ACTIVATE(state, data) {
    state.active = data;
  },
};

const actions = {
  fetchAssets: firestoreAction(({ bindFirestoreRef }, user) => {
    return bindFirestoreRef(
      'assets',
      fb.db.collection('assets').where('owners', 'array-contains', user.uid)
    );
  }),
  select({ commit }, fbAssetRef) {
    commit('SELECT', fbAssetRef);
  },
  deselect({ commit }, fbAssetRef) {
    commit('DESELECT', fbAssetRef);
  },
  activate({ commit }, fbAssetRef) {
    commit('ACTIVATE', fbAssetRef);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};
